var module = 'main', name = 'main/config/locales/en.json', content = {
  "common": {
    "time_unit": {
      "minutes": "minutes"
    },
    "contact_method_kinds": {
      "codepager": "Code Pager",
      "speed_dial": "Speed dial",
      "fax": "Fax",
      "home": "Home",
      "mobile": "Mobile",
      "other": "Other",
      "pager": "Pager",
      "pharmacy": "Pharmacy",
      "switchboard": "Operator",
      "work": "Work"
    },
    "gender": {
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "territories": {
      "be": "Belgium",
      "ch": "Switzerland",
      "fr": "France",
      "us": "United States",
      "ab": "Alberta",
      "bc": "British Columbia",
      "mb": "Manitoba",
      "nb": "New Brunswick",
      "nl": "Newfoundland",
      "nt": "Northern Territories",
      "ns": "Nova Scotia",
      "nu": "Nunavut",
      "on": "Ontario",
      "pe": "Prince Edward Island",
      "qc": "Quebec",
      "sk": "Saskatchewan",
      "yt": "Yukon"
    },
    "phone": "Phone",
    "add_cell_phone": "Add a cell number",
    "add_phone": "Add a telephone number",
    "selection": "Selection"
  },
  "display_name": {
    "doctor": "Dr.",
    "you": "(you)"
  },
  "switch_language": "Version française",
  "switch_language_short": "FR",
  "page_error": "We are sorry, an error occurred.<br>Please return to your clinic’s website and try again.",
  "date": "{{date}} at {{time}}",

  "header": {
    "logout": "Sign out",
    "manage_profile": "Edit my profile"
  },

  "patient_selection": {
    "title": "Several patients are linked to this account",
    "subtitle": "For whom do you wish to make the appointment?"
  },

  "choose_reason": {
    "title": "Choose type of appointment",
    "next_link_text": "See availabilities"
  },

  "datepicker": {
    "placeholder": "Select a date..."
  },

  "end_message": {
    "no_appointment": "We can not give you an appointment for this service",
    "send_appointment_request_title": "A service request for a {{descriptionReason}} appointment has been sent to the clinic",
    "send_appointment_request_description": "We will process your request and contact you shortly.",
    "choose_preferences": "Please choose the preferred moment for a possible appointment",
    "preferences_saved": "Your preferences have been submitted to the clinic."
  },

  "flash_update_profile": {
    "no_address": {
      "no_phone": "No civic addresses or phone numbers are in your profile.",
      "with_phone": "Is your phone number still {{phoneNumber}}? Also, no civic address is registered in your profile."
    },
    "with_address": {
      "no_phone": "Are you still domiciled at {{address}}? Also, you do not have a phone number in your profile.",
      "with_phone": "Are you still domiciled at {{address}}? Is your phone number still {{phoneNumber}}?"
    },
    "thank_you_note": "Thank you for helping us by keeping your personal information up-to-date in your profile.",
    "edit_profile": "Edit my information",
    "up_to_date": "Everything is up-to-date"
  },
  "preferences_page": {
    "titles": {
      "details": "Preferences",
      "types": "Select the appointment type",
      "location": "Select your location",
      "availabilities": "Select the desired time",
      "moment": "I want an appointment",
      "preferences": "I prefer the",
      "select_hcp": "If desired, select the specialist(s) you wish to see",
      "none_selected": "If no specialist is selected, they will all be considered for the choice of availabilities."
    },
    "visit_reason": {
      "title": "Select reason",
      "label": "Can you tell us the reason of your visit?",
      "legend": "This is for information purposes only.",
      "placeholder": "Select",
      "specify": "Please specify.",
      "max_characters": "50 characters max",
      "other": "Other"
    },
    "manitoba_language_access": {
      "title": "Language Access",
      "label": "Please select one of the following options",
      "legend": "ASL requires 7 day lead time to arrange"
    },
    "warning": {
      "period": "Unfortunately, there are no availabilities in your {{familyDoctorLabel}}'s schedule for this date.",
      "offerings": "This type of appointment is not offered online. Please contact your clinic at {{phone}}."
    },
    "actions": {
      "notify_me": "Manage my notifications"
    },
    "labels": {
      "asap": "As soon as possible",
      "period": "My preferred date",
      "morning": "morning",
      "afternoon": "afternoon",
      "evening": "evening",
      "whenever": "whenever",
      "consecutive_delay": "Select the max. time between appointments"
    }
  },

  "availability_page": {
    "navigation_warning": {
      "explanations": "This reserved availibility will be lost if you leave the booking process at this stage.",
      "title": "Do you really want to leave?"
    },
    "title_your_time_slot": "Availability",
    "title_fallback": "We found you an alternative",
    "more_availabilities_body": "Suggest another availability",
    "no_more_availabilities": {
      "title": "There is no other availability.",
      "body": "Confirm this appointment or try again later."
    },
    "no_availability": {
      "warning": {
        "with_preferences": "There are currently no availabilities corresponding to your preferences.",
        "without_preferences": "There are currently no availabilities.",
        "walkin": "Unfortunately, there are currently no availabilities for a walk-in appointment.",
        "family_doctor": "Unfortunately, there are currently no availabilities with your {{familyDoctorLabel}}.",
        "other_service": "Unfortunately, there are currently no availabilities for a {{reasonKind}} appointment."
      },
      "title": "What would you like to do?",
      "message": "You can configure notifications to be notified by email when your {{familyDoctorLabel}} has new availabilities.",
      "manage_notifications": "Manage my notifications",
      "edit_preferences": "Manage my preferences"
    },
    "appointment_error": {
      "warning": "An error occurred during the confirmation. Unfortunately, the appointment is no longer available.",
      "title": "What would you like to do?",
      "search_availabilities": "Search another availability",
      "edit_preferences": "Manage my preferences"
    },
    "time_elapsed": {
      "title": "Your time has run out.",
      "message": "You lost your reserved availability. Do you want to see other availabilities?",
      "propose_another": "Suggest another availability"
    },
    "to": "to",
    "at": "at",
    "time_left": "There are <strong>{{timer}} minutes</strong> left to confirm your choice.",
    "cancel": "Cancel",
    "back_link_text": "Back to appointment type",
    "next_link_text": "I accept",
    "next_walkin_link_text": "I accept this walk-in appointment",
    "long_operation_notice": "This operation may take several seconds.",
    "in_person": "In-person appointment",
    "virtual": "Virtual appointment",
    "raven_message": "<p>Limited intake appointments are available online for Fridays only. Check back weekly for new appointments or walk-in to Raven Song CYMHSU at 300-2450 Ontario Street, Vancouver on Fridays between 9am to 3:30pm on a first come, first served basis. If you require assistance, please call 604-331-8908.</p><p>For other walk-in options, visit <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong></p>",
    "three_bridges_message": "<p>Limited intake appointments are available online for Thursdays only. Check back weekly for new appointments or walk-in to Three Bridges CYMHSU at 101-1128 Hornby St, Vancouver on Thursdays from 9am-3:30pm on a first come, first served basis. If you require assistance, please call 604-331-8908.</p><p>For other walk-in options, visit <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong>.</p>",
    "northeast_message": "<p>Limited intake appointments are available online for Mondays and Wednesdays only. Check back weekly for new appointments or walk-in to Northeast CYMHSU at 355-2750 E Hastings St, Vancouver on Mondays from 9am-3:30pm or Wednesdays from 12pm-6pm on a first come, first served basis. If you require assistance, please call 604-675-3896.</p><p>For other walk-in options, visit <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong></p>",
    "pacific_message": "<p>Limited intake appointments are available online for Tuesdays and Thursdays only. Check back weekly for new appointments or walk-in to Pacific Spirit CYMHSU at 2110 W 43rd Avenue, 3rd Floor, Vancouver on Tuesdays from 12:00-6:00pm or Thursdays from 9:00am-3:30pm on a first come, first served basis. If you require assistance, please call 604-267-3970.</p><p>For other walk-in options, visit <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong></p>"
  },

  "linked_patients_page": {
    "title": "Select the family member(s) for whom you wish to book an appointment",
    "subtitle": "For different types of appointments, select only one member at a time"
  },

  "appointment": {
    "title_your_appointment": "Your upcoming appointment",
    "title_your_child_appointment": "{{patientName}}'s upcoming appointment",
    "patient_label": "Patient",
    "reason_label": "Appointment type",
    "professional_label": "Healthcare professional",
    "moment_label": "Date and time",
    "location_label": "Location",
    "reminder_notice_title": "Reminder",
    "reminder_notice_text_one_hour": "Reminders will be sent by <strong>{{type}}</strong> at <strong>{{reminders}}</strong> {{longTermTime}} hours prior to your appointment, then {{shortTermTime}} hour before.",
    "reminder_notice_text_several_hours": "Reminders will be sent by <strong>{{type}}</strong> at <strong>{{reminders}}</strong> {{longTermTime}} hours prior to your appointment, then {{shortTermTime}} hours before.",
    "reminder_notice_text_one_reminder_one_hour": "A reminder will be sent by <strong>{{type}}</strong> at <strong>{{reminders}}</strong> {{longTermTime || shortTermTime}} hour prior to your appointment.",
    "reminder_notice_text_one_reminder_several_hours": "A reminder will be sent by <strong>{{type}}</strong> at <strong>{{reminders}}</strong> {{longTermTime || shortTermTime}} hours prior to your appointment.",
    "cancel_button_text": "Cancel this appointment",
    "confirmation_return_home_text": "If you wish to cancel this appointment, please return to ",
    "confirmation_return_home_link": "your home page.",
    "confirmation_approx_time": "Please note that the appointment time is approximate.",
    "form": {
      "preliminary_informations": "Preliminary information prior to the booking process"
    },
    "virtual_appointment": "Virtual Appointment",
    "arrived": "Arrival reported"
  },

  "appointment_cancel": {
    "title": "Appointment cancellation",
    "message": "Do you want to cancel your appointment",
    "infos": "with",
    "walkin": "Do you want to cancel your walk-in appointment",
    "date": "on {{date}} at {{time}}?",
    "walkin_date": "of {{date}} at {{time}}?",
    "confirm_cancel": "Confirm cancellation",
    "keep_appointment": "Keep this appointment",
    "manitoba_vaccination_title": "Are you sure you want to cancel your COVID-19 vaccination appointments?",
    "manitoba_vaccination_message": "COVID-19 vaccination requires two separate appointments. If you cancel any of those appointments beforehand, the other one will also be cancelled."
  },

  "appointment_request_cancel": {
    "title": "Service request cancellation",
    "message": "Do you want to cancel your service request ({{description}})",
    "infos": "with",
    "date": "that was taken on {{date}} at {{time}}?",
    "confirm_cancel": "Confirm cancellation",
    "keep_appointment_request": "Keep this service request"
  },

  "breadcrumb": {
    "title": "Book an appointment",
    "my_appointments": "Go back to my appointments",
    "appointments_of": "Go back to {{name}}'s appointments",
    "steps": {
      "reasons": "Selection of service",
      "form": "Form",
      "preferences": "Preferences",
      "patients": "Patients"
    }
  },

  "footer": {
    "assistance": "For assistance booking an appointment, please call {{phoneNumber}}",
    "terms_and_conditions": "Terms of Use",
    "privacy_policy": "Privacy Policy"
  },

  "date_format": {
    "long": "MMMM Do HH:mm",
    "day_and_month": "MMMM Do",
    "day_month_and_year": "MMMM Do YYYY",
    "dayname_day_month_and_year": "dddd MMMM Do YYYY",
    "dayname_day_month_and_year_and_time": "dddd MMMM Do YYYY [at] HH:mm",
    "day_month_year_and_time": "MMMM D, YYYY [at] HH:mm",
    "day_month_and_time": "MMMM Do [at] HH:mm",
    "dayname_comma_day_month_year": "dddd, MMMM D, YYYY",
    "only_time": "HH:mm"
  },

  "follow_up": {
    "family_doctor": "Your {{familyDoctorLabel}}, {{professional}} has the following availability:",
    "walk_in": "The following appointment is available: {{description}}",
    "other": "There is also a {{reasonKind}} appointment available with {{professional}}:",
    "other_confidential": "There is also a {{reasonKind}} appointment available:"
  },

  "global": {
    "yes": "Yes",
    "no": "No",
    "actions": "Actions"
  },

  "flash": {
    "error": {
      "title": "Oops, an error occured."
    }
  },

  "loading": {
    "generic": "Loading...",
    "availability": "Looking for availabilities...",
    "appointment": "Appointment confirmation in progress...",
    "long_operation_notice": "This may take several seconds. Thank you for waiting."
  },

  "actions": {
    "btn_cancel": "Cancel",
    "btn_edit": "Edit",
    "next": "Next",
    "join": "Join",
    "send": "Send"
  },

  "attachments": {
    "select_a_file": "Select a file",
    "new_file": "Add a file",
    "errors": {
      "file_too_big": "File size exceeds {{size}}MB."
    }
  },

  "dayNamesShort": {
    "sunday": "S",
    "monday": "M",
    "tuesday": "T",
    "wednesday": "W",
    "thursday": "T",
    "friday": "F",
    "saturday": "S"
  },

  "bytes":{
    "bytes": "b",
    "kilobytes": "kB",
    "megabytes": "MB",
    "gigabytes": "GB",
    "terabytes": "TB",
    "petabytes": "PB"
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/config/locales/en.json
// module id = 1328
// module chunks = 0